import { render, staticRenderFns } from "./image-uploader.vue?vue&type=template&id=242dc0b6"
import script from "./image-uploader.vue?vue&type=script&lang=js"
export * from "./image-uploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports